module.exports = __webpack_public_path__ + "static/media/country_bj.3d92c836.webp";